import React, { Component } from 'react'
import { withNamespaces } from 'react-i18next'

class Footer extends Component {
  render() {
    const { t } = this.props;

    return (
      <footer>
        <div className="footer-area mt-5" style={{position: "fixed", bottom: "0px", width: "100%", zIndex:"5"}}>
          <div className="container">
            <div className="footer-bottom">
              <div className="d-flex">
                    <p style={{color:"#ffffff"}}>
                    Thailand Golf Association | {t('contact1')} | {t('contact2')} | {t('contact3')}</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default withNamespaces()(Footer);